/* global Swiper */
document.querySelectorAll( '.b-patient-stories' ).forEach( ( block ) => {

	const blockSwiper = block.querySelector( '.b-patient-stories .swiper' );

	new Swiper( blockSwiper, {
		autoplay: {
			delay: 3000,
		},
		spaceBetween: 16,
		loop: true,
		slidesPerView: 1,
		slideClass: 'b-patient-stories__box',
		breakpoints: {
			1100: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );

} );
